import type { ProductStatus } from "../components/listing/shared/StatusTabs";
import type { ProductStatus as ProductStatusType } from "../types/ProductListing";

export const apiToUiStatusMapping: Record<ProductStatusType, ProductStatus> = {
  all: "all", live: "active", draft: "draft", disabled: "disabled", banned: "banned",
  deleted: "deleted", sold_out: "soldOut", in_process: "inProcess", failed_publish: "failedPublish",
};

export const uiToApiStatusMapping: Record<ProductStatus, ProductStatusType> = {
  all: "all", active: "live", draft: "draft", disabled: "disabled", banned: "banned",
  deleted: "deleted", draftMode: "draft", soldOut: "sold_out", inProcess: "in_process", failedPublish: "failed_publish",
};
